import React from 'react';

import Layout from '../components/Layout/Layout';
import HomePageImg from '../assets/img/home.jpeg';
import ThreeIcons from '../components/HomePage/ThreeIcons';
import HelpBlock from '../components/HomePage/HelpBlock';
import GetQuote from '../components/HomePage/GetQuote';
import SEO from '../components/SEO/seo';

export default function IndexPage() {
  return (
    <Layout
      paralaxImg={HomePageImg}
      heading='Leaving your home feeling like new. Deelightful. '
    >
      <SEO
        title='Domestic & Commercial Cleaning Services | Deelightful Cleaning'
        description='We know you want a top home cleaning service and a trusted maid. Deelightful Cleaning is the best South Wales cleaning solution. Book today!'
      />
      <GetQuote />
      <ThreeIcons />
      <HelpBlock />
    </Layout>
  );
}
